import { render, staticRenderFns } from "./xtSuDetailReportList.vue?vue&type=template&id=3590a82e"
import script from "./xtSuDetailReportList.vue?vue&type=script&lang=js"
export * from "./xtSuDetailReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports